import Vue from 'vue';
import Switches from 'vue-switches';

Vue.use(Switches);
